import type { StrictTitle } from '../../types';

const ComposeMessageExtensionTitles: StrictTitle[] = [];

const MessageExtensionTitles: StrictTitle[] = [...ComposeMessageExtensionTitles];

export { ComposeMessageExtensionTitles, MessageExtensionTitles };
